<template>
    <BreadCrumb PageTitle="Correction" />
    <SessionACorrige />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import SessionACorrige from "../../components/Composition/SessionACorrige.vue";
  
    export default defineComponent({
      name: "SessionsACorrigerPage",
      components: {
        BreadCrumb,
        SessionACorrige,
      },
    });
  </script>